// Pure helpers for surfacing senior-appointment booking failures. Kept
// dependency-free (no React / spraypaint) so they can be unit-tested in
// isolation. The customer scheduler used to swallow save failures and show a
// misleading "refresh and try again" toast; these turn the real server reason
// into something we can log and show.

// Pull human-readable messages out of a spraypaint model's validation errors
// and/or a thrown error. Returns a de-duped array of strings.
export const collectBookingErrors = (orderPackage, err) => {
  const messages = []

  const modelErrors = orderPackage && orderPackage.errors
  if (modelErrors && typeof modelErrors === 'object') {
    Object.values(modelErrors).forEach((e) => {
      if (!e) return
      const msg = e.message || e.title || e.fullMessage || (typeof e === 'string' ? e : null)
      if (msg) messages.push(msg)
    })
  }

  if (err && err.message) messages.push(err.message)

  return [...new Set(messages.filter(Boolean))]
}

// The toast text shown to the customer when a booking step fails. Uses the real
// server reason when we have one; otherwise a contact fallback (never the old
// "refresh", which provably does not help).
export const bookingErrorMessage = (action, errors) => {
  const reason = errors && errors.length
    ? errors.join(' ')
    : 'Please try again, or call us at (209) 567-0748.'

  return `We couldn't ${action}: ${reason}`
}
